module.exports = __webpack_public_path__ + "dingbeauty-landing/img/industry_03@1.0bf76d8d.png";